module.exports = __webpack_public_path__ + "img/slim_cleanstation09.16c9b512.jpg";